module.exports = __webpack_public_path__ + "static/media/layers.11a558e9.svg";